import * as Sentry from "@sentry/react";
import { environment, SENTRY_DSN } from "./config";

function initializeSentry() {
  if (environment !== "development") {
    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      autoSessionTracking: true,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
      environment: "app",
      tracesSampleRate: 0.1,
    });
  }
}

function capture(err, extra) {
  console.log("capture", err);
  if (Sentry && err) {
    console.log("capture", err);
    Sentry.captureException(err, { extra });
  }
}

export { initializeSentry, capture };
